module.exports = __webpack_public_path__ + "static/media/dataSources.7e376259.png";